
import fileSaver from "file-saver"
export const baseUrl = process.env.REACT_APP_API_URL

let isRedirecting = false

export const fetchSinToken = (endpoint, data, method = 'GET') => {

    const url = `${baseUrl}/${endpoint}`;

    if (method === 'GET') {
        return fetch(url);
    } else {
        return fetch(url, {
            method,
            headers: {
                'Content-type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    }

}

export const fetchConToken = async (endpoint, data, method = 'GET', requestOptions = {}) => {

    const url = `${baseUrl}/${endpoint}`;
    const token = localStorage.getItem('token') || '';
    let resp = null

    if (method === 'GET') {

        resp = await fetch(url, {
            method,
            signal: requestOptions.signal,
            headers: {
                'x-token': token
            }
        });


    } else {

        resp = await fetch(url, {
            method,
            signal: requestOptions.signal,
            headers: {
                'x-token': token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify(data)
        });


    }

    // detectar sesión expirada
    if (resp?.status === 401) {

        localStorage.removeItem('token');

        const publicRoutes = [
            '/login',
            '/password/reset',
            '/password/reset/confirm',
            '/onboarding',
            '/onboarding/signup',
        ];

        const isPublicRoute = publicRoutes.some(route =>
            window.location.pathname.startsWith(route)
        );

        if (!isRedirecting && !isPublicRoute) {
            isRedirecting = true;
            const currentPath = window.location.pathname + window.location.search;
            localStorage.setItem('redirectAfterLogin', currentPath);
            window.location.href = "/login";
        }

    }

    return resp

}

export const fetchConTokenFile = async (endpoint, data, method = 'GET') => {

    const url = `${baseUrl}/${endpoint}`;
    const token = localStorage.getItem('token') || '';

    if (method === 'GET') {

        const resp = await fetch(url, {
            method,
            responseType: 'arraybuffer',
            headers: {
                'x-token': token
            }
        });

        // detectar sesión expirada
        if (resp.status === 401) {
            localStorage.removeItem('token')
            window.location.href = '/login'
        }

        const result = await resp.arrayBuffer()

        var file = new Blob([result], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        window.open(fileURL);

        return { ok: true }

    } else {

        const resp = await fetch(url, {
            method,
            headers: {
                'x-token': token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify(data)
        })

        // detectar sesión expirada
        if (resp.status === 401) {
            localStorage.removeItem('token')
            window.location.href = '/login'
        }

        return resp

    }

}


export const fetchConTokenFilePDFBuffer = async (endpoint, data, method = 'GET') => {

    const url = `${baseUrl}/${endpoint}`;
    const token = localStorage.getItem('token') || '';

    if (method === 'GET') {

        const data = await fetch(url, {
            method,
            responseType: 'arraybuffer',
            headers: {
                'x-token': token
            }
        });

        const result = await data.arrayBuffer()

        var file = new Blob([result], { type: 'application/pdf' });
        var fileURL = URL.createObjectURL(file);
        // window.open(fileURL);

        return {
            ok: true,
            url: fileURL
        }

    } else {

        return fetch(url, {
            method,
            headers: {
                'x-token': token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify(data)
        })

    }

}

export const fetchConTokenFileExcel = async (endpoint, data, method = 'GET', fileName = null) => {

    const url = `${baseUrl}/${endpoint}`;
    const token = localStorage.getItem('token') || '';

    if (method === 'GET') {

        const data = await fetch(url, {
            method,
            responseType: 'arraybuffer',
            headers: {
                'x-token': token
            }
        });

        const resultBuffer = await data.arrayBuffer()
        const fileNameDefault = `excel_${new Date()}_`
        fileSaver.saveAs(new Blob([resultBuffer], { type: "application/octet-stream" }), `${fileName || fileNameDefault}.xlsx`);

        return { ok: true }

    } else {

        return fetch(url, {
            method,
            headers: {
                'x-token': token,
                'Content-type': 'application/json'
            },
            body: JSON.stringify(data)
        })

    }

}
